<template>
  <div class="animated fadeIn">
    <div>
      <vue-good-table
        :columns="columns"
        :rows="bons"
        :search-options="{
          enabled: true,
          skipDiacritics: true,
          placeholder: 'Recherchez dans tous le tableau',
         }"
         :key="vuegood"
      >

        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'delete'">
                <button type="button" class="btn btn-primary" @click="detailsBon(props.row)">
                      Voir détails du bon
                </button>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
        </template>

      </vue-good-table>


      <el-dialog
        title="Details du bon de commande"
        :visible.sync="detailsBonVisible"
        width="70%"
        center>
        <span>
          <el-card class="box-card">
            <el-row>
              <el-col :span="12" class="primary">
                <b>Libelle:</b>
              </el-col>
              <el-col :span="12">
                <el-input readonly :value="current.libelle"/>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="primary">
                <b>Date de réalisation:</b>
              </el-col>
              <el-col :span="12">
                <el-date-picker readonly type="date" placeholder="Date de réalisation" v-model="current.date_realisation"
                 value-format="yyyy-MM-dd"
                 style="width: 100%;"/>
              </el-col>
            </el-row>
            <div style="margin-bottom:5px"></div>
            <el-row>
              <el-col :span="12" class="primary">
                <b>Télécharger le bon:</b>
              </el-col>
              <el-col :span="12">
                <el-button @click="downloadBon" plain icon="el-icon-download" type="primary">Télécharger</el-button>                
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="primary">
                <b>Commentaire:</b>
              </el-col>
              <el-col :span="12">
                
              </el-col>
            </el-row>
            <el-row>
              <el-input readonly type="textarea" :value="current.commentaire"/>
            </el-row>
          </el-card>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailsBonVisible = false">Fermer</el-button>
          <!-- <el-button type="primary" @click="centerDialogVisible = false">Confirmer</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';



export default {
  name: 'bons',

  data: function () {
    return {
      current:{},
      columns:[
        {
          label:"Libelle",
          field:"libelle",
          filterOptions: {
            enabled: true, 
            placeholder: '', 
          },
        },
        {
          label:"Commentaire",
          field:"commentaire",
          filterOptions: {
            enabled: true, 
            placeholder: '', 
          },
        },
        {
          label:"Actions",
          field:"delete"
        },
      ],
      rows:[

      ],
      detailsBonVisible:false,
      vuegood:0
    }
  },
  methods:{
     ...mapActions([
      'getBons',
      'setOuvertYn'
    ]),
    detailsBon(props){
      console.log('props :', props);
      this.current = props;
      this.detailsBonVisible = true,
      this.setOuvertYn(props.id);
    },
    downloadBon(){
      window.open(this.current.chemin_fichier,'_blank');
    }
  },
  computed:{
   ...mapState({
     bons:state=>state.bons.bons
   })
  },
  mounted(){
    // this.getMessages()
    this.getBons(this).then(res=>{
      console.log('res',res);
      this.vuegood +=1;
    });/* .then(res=>{
      this.bons.push({
        delete:e=>{console.log('boom');}
      })
    }) */;
  }
}
</script>


<style scoped>
  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>